export default "__VITE_ASSET__BhppLMku__"